import { useSelector } from "react-redux";

import { willUpgradeSubscription } from "helpers/subscription";
import { getNonViewersCount } from "store/entities/agents";
import { getBilling } from "store/entities/billing";
import { selectIsManagedByShopify } from "store/entities/integrations";
import { selectManagedByPartner } from "store/entities/license";
import { selectCurrentSubscription, selectSeatsCount } from "store/entities/subscriptions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useUpgradeSubscription = (paidUsersToAdd: number) => {
  const subscription = useSelector(selectCurrentSubscription);
  const billing = useSelector(getBilling);
  const seatsCount = useSelector(selectSeatsCount);
  const isManaged = useSelector(selectIsManagedByShopify) || useSelector(selectManagedByPartner);

  const nonViewersCount = useSelector(getNonViewersCount);

  const willUpgrade = willUpgradeSubscription(subscription, billing, nonViewersCount, paidUsersToAdd, isManaged);

  const exceededBy = Math.max(0, nonViewersCount + paidUsersToAdd - seatsCount);

  return {
    willUpgrade,
    exceededBy,
  };
};
